import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loot-boxes-list" }

import {onMounted} from "vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import LootBoxBundle from "@/components/store/LootBoxBundle.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LootboxesStore',
  props: {
    lootBoxes: {}
  },
  setup(__props: any) {

const props = __props

onMounted(async () => {
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.lootBoxes, (item) => {
      return (_openBlock(), _createBlock(LootBoxBundle, {
        key: item.id,
        item: item
      }, null, 8, ["item"]))
    }), 128))
  ]))
}
}

})